import { useEffect } from 'react';
import { UserRole } from '@izettle/constants';
import { useUser } from '@izettle/react';
import { useService } from '../../hooks/use-service.js';
import { KnownService } from '../../providers/services.js';
import { jsx, Fragment } from 'react/jsx-runtime';

const StaffRedirect = _ref => {
  let {
    allowStaff,
    children
  } = _ref;
  const {
    user
  } = useUser();
  const portalUrl = useService(KnownService.Portal);
  const isOwner = user.userRole === UserRole.Owner;
  useEffect(() => {
    if (!isOwner && !allowStaff) {
      window.location.href = `${portalUrl}/staff`;
    }
  }, [isOwner]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return isOwner ? /*#__PURE__*/jsx(Fragment, {
    children: children
  }) : null;
};

export { StaffRedirect };
//# sourceMappingURL=staff-redirect.js.map
